// extracted by css-extract-rspack-plugin
export default {"cls1":"AutoCompleteResultRow-cls1_o_h","cls2":"AutoCompleteResultRow-cls2_F4K AutoCompleteResultRow-cls1_o_h"};